import IconButtonWithToolTip from "./IconButtonWithToolTip";
import React from "react";
import { SharedButtonProps } from "./types";
import classnames from "classnames";
const styles = require("./styles.less");

interface FontAwesomeIconButtonWithToolTipProps extends SharedButtonProps {
    iconClassName: string;
}

export const FontAwesomeIconButtonWithToolTip = ({ iconClassName, disabled, tabIndex, buttonRef, style, toolTipContent, onClick }: FontAwesomeIconButtonWithToolTipProps) => {
    return (
        <IconButtonWithToolTip
            icon={<em className={classnames("fa", iconClassName, styles.fontAwesomeIcon)} aria-hidden="true" />}
            onClick={onClick}
            toolTipContent={toolTipContent}
            disabled={disabled}
            tabIndex={tabIndex}
            buttonRef={buttonRef}
            style={style}
        />
    );
};

export default FontAwesomeIconButtonWithToolTip;
